import React, { useEffect, useState } from 'react';

import {
  getAllMonitors,
  getMonitorCustomMetricsByPublisherID,
} from '~/src/dash/api/monitors/monitors_methods';
import {
  EMonitorAlertTimeframe,
  EMonitorMetricDirection,
  EMonitorObjectType,
  EMonitorThresholdComputationType,
  EMonitorType,
  IMonitor,
  IMonitorAlertHistory,
  IMonitorCustomMetric,
  IMonitorNotificationHistory,
  IMonitorNotificationSettings,
} from '~/src/dash/api/monitors/monitors_models';
import {
  generateMonitorCustomMetricList,
  generateMonitorMetricMenuList,
  TargetedMetricConditionSingle,
} from '~/src/dash/api/monitors/monitors_utils';
import { EBool } from '~/src/dash/api/types/bool';
import { EditMonitor } from '~/src/dash/components/monitor/edit-monitor';
import { IStore } from '~/src/dash/reducers/store';
import { IMenuList } from '~/src/dash/types/menuList';
import {
  IHistoryProps,
  ISessionStateProps,
  IUserStateProps,
  IWithStylesProps,
} from '~/src/dash/types/props';
import { decorate } from '~/src/dash/utils/decorator';
import { LoadingView } from '~/src/dash/views/loading-view';

interface IProps extends IWithStylesProps, ISessionStateProps, IUserStateProps, IHistoryProps {}

export function MonitorNewViewInner(props: IProps) {
  const [allMonitors, setAllMonitors] = useState([] as IMonitor[]);
  const [fetchedAllMonitors, setFetchedAllMonitors] = useState(false);
  const [monitorCustomMetrics, setMonitorCustomMetrics] = useState([] as IMonitorCustomMetric[]);
  const [fetchedCustomMetrics, setFetchedCustomMetrics] = useState(false);
  const searchString = 'bulk_edit_ids';
  const bulkUpdateEnabled = props.location.search.indexOf(searchString);
  let bulkUpdateIDs = [] as string[];
  if (bulkUpdateEnabled > -1) {
    bulkUpdateIDs = props.location.search
      .slice(bulkUpdateEnabled + searchString.length + 1)
      .split(',');
  }

  useEffect(() => {
    fetchAllMonitors();
    fetchCustomMetrics();
  }, []);

  const fetchCustomMetrics = () => {
    getMonitorCustomMetricsByPublisherID(props.session.publisher.ID).then((data) => {
      // transform into IMenuList
      if (data[0]) {
        setMonitorCustomMetrics(data[0]);
        setFetchedCustomMetrics(true);
      }
    });
  };

  const fetchAllMonitors = () => {
    getAllMonitors(props.session.publisher.ID).then(([monitors, err]) => {
      if (err) {
        console.error(err);
      } else {
        setAllMonitors(monitors as IMonitor[]);
        setFetchedAllMonitors(true);
      }
    });
  };

  return fetchedCustomMetrics && fetchedAllMonitors ? (
    <EditMonitor
      monitor={
        {
          Active: EBool.EBool_TRUE,
          EnableAutoDisable: EBool.EBool_FALSE,
          EnableTargetAllActive: EBool.EBool_FALSE,
          MonitorType: EMonitorType.MonitorType_SINGLE,
          ID: 0,
          IsSuperAdmin: EBool.EBool_FALSE,
          PublisherID: +props.session.publisher.ID,
          CreatedByPublisherID: +props.user.publisher.ID,
          CreatedByUserID: +props.user.user.ID,

          AlertThresholds: {
            AlertRecoveryThreshold: 0,
            AlertThreshold: 0,
            WarningRecoveryThreshold: 0,
            WarningThreshold: 0,
            IsPercentage: false,
          },
          AlertTimeframe: EMonitorAlertTimeframe.MonitorAlertTimeframe_2H,
          AveragePeriod: EMonitorAlertTimeframe.MonitorAlertTimeframe_1H,
          CreatedAt: new Date(),
          MetricDirection: EMonitorMetricDirection.MonitorMetricDirection_ABOVE,
          PercentageGranularity: 0,
          PercentagePeriod: 0,
          TargetedMetric: 0,
          TargetedObject: '',
          TargetedObjectType: EMonitorObjectType.MonitorObjectType_UNKNOWN,
          ThresholdComputation:
            EMonitorThresholdComputationType.MonitorThresholdComputationType_SUM,
          Name: 'Monitor Name',
          AlertHistory: [] as [] as IMonitorAlertHistory[],
          NotificationsHistory: [] as IMonitorNotificationHistory[],
          NotificationsSettings: [] as IMonitorNotificationSettings[],
          MonitorCustomMetricID: 0,
          MonitorCustomMetric: {} as IMonitorCustomMetric,
          targetedMetricType: TargetedMetricConditionSingle,
          monitorDefinedMetricsList: generateMonitorMetricMenuList(
            false,
            undefined,
            undefined,
            TargetedMetricConditionSingle,
          ) as IMenuList,
          monitorCustomMetricsList: generateMonitorCustomMetricList(
            monitorCustomMetrics,
          ) as IMenuList,
          monitorCustomMetrics,
        } as Partial<IMonitor>
      }
      allMonitors={allMonitors}
      bulkUpdateIDs={bulkUpdateIDs}
    />
  ) : (
    <LoadingView active={true} text='Loading Monitor' />
  );
}

export const MonitorNewView = decorate(
  {
    redux: (state: IStore) => {
      return {
        user: state.user,
        session: state.session,
      };
    },
    router: true,
  },
  MonitorNewViewInner,
);
